<template>
    <div>
        <div class="bg-dark m-b-30">
            <div class="container">
                <div class="row p-b-60 p-t-60">
                    <div class="col-md-6 text-white p-b-30">
                        <div class="media">
                            <div class="avatar avatar mr-3">
                                <div class="avatar-title bg-success rounded-circle mdi mdi-store"></div>
                            </div>
                            <div class="media-body">
                                <h3 class="p-t-10">{{ pageTitle }}</h3>
                                <p class="opacity-75"></p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 text-center m-b-30 ml-auto">
                        <div class="text-md-right">
                            <v-btn color="primary" v-can="'department.read'" :to="{name: 'stores'}" class="mx-1">
                              <v-icon class="el-icon-s-order" left/> {{ $t('store.button.all') }}
                            </v-btn>
                            <v-btn color="success" v-can="'department.create'" :to="{name: 'create-store'}" class="mx-1">
                                <v-icon left>mdi-plus</v-icon>{{ $t('store.button.create') }}
                            </v-btn>
                        </div>
                    </div>
                </div>
            </div>
        </div>
<!--        <create-department @close="closeCreateDialog" :display="displayCreateDialog" @created="departmentCreated"></create-department>-->
        <transition name="slide-fade">
            <router-view @parent-title="updateTitle"/>
        </transition>
    </div>
</template>

<script>
// import CreateDepartment from './Modal/CreateEditDepartment'
export default {
  name: 'Departments',
  // components: { CreateDepartment },
  data () {
    return {
      pageTitle: '',
      displayCreateDialog: false
    }
  },
  methods: {
    updateTitle (title) {
      this.pageTitle = title
    },
    showCreateDialog () {
      this.displayCreateDialog = true
    },
    closeCreateDialog () {
      this.displayCreateDialog = false
    },
    departmentCreated (data) {
      this.$emit('new-department', data)
    }
  },
  async mounted () {
    this.$emit('parent-title', this.$t('department.title'))
    try {
      await this.withLoading(async () => {
        const data = await this.$departmentService.getDepartments()
        this.departments = data
      }, 'loading')
    } catch (error) {
      // Error is already handled by the global interceptor
      console.log('Component caught error in getDepartments:', error)
    }
  }
}
</script>

<style scoped>

</style>
